module.exports = __webpack_public_path__ + "img/kr-product-agency-card4-4.6345d26.png";